// Mock data for LEXCEED Law Firm Website

export const firmInfo = {
  name: "LEXCEED",
  tagline: "Legal Expertise. Exceeding Benchmarks.",
  email: "info@lexceed.in",
  phone: "+91 9988 77 9661",
  linkedIn: "https://www.linkedin.com/company/lexceed/about/",
  logo: "/images/lexceed-logo.png",
  description: "Delivering exceptional legal counsel with institutional expertise and boutique agility. Advising corporates, venture ecosystem, and institutions on complex domestic and cross-border matters."
};

export const founderProfile = {
  name: "Ayushi Pandey",
  title: "Founding Partner",
  image: "/images/ayushi-pandey.jpeg",
  email: "ayushi@lexceed.in",
  linkedIn: "https://www.linkedin.com/in/ayushi-pandey-45569253/",
  bio: "Corporate and transactions lawyer with over a decade of experience advising on complex domestic and cross-border matters.",
  expertise: [
    "Corporate and M&A Transactions",
    "Joint Ventures & Strategic Partnerships",
    "Venture Capital & Private Equity",
    "FEMA & Cross-border Transactions",
    "Real-Estate Transactions & Advisory",
    "Employment & Labor Law",
    "Intellectual Property & Technology Law",
    "Corporate Governance & Compliance",
  ],
  expertiseHome: [
    "Corporate and M&A Transactions",
    "Venture Capital & Private Equity",
    "FEMA & Cross-border Transactions",
    "Commercial Contracts, Employment & IP Laws"
  ],
  education: [
    {
      degree: "Registered",
      institution: "Bar Council of India",
      // honor: "Harlan Fiske Stone Scholar",
      year: "2016"
    }, {
      degree: "LL.M.",
      institution: "Columbia Law School",
      honor: "Harlan Fiske Stone Scholar",
      year: "2022"
    },
    {
      degree: "B.A L.L.B. (Hons.)",
      institution: "Rajiv Gandhi National University of Law, Punjab",
      year: "2016"
    }
  ],
  enrollment: "Enrolled with Bar Council of India",
  priorExperience: [
    "J. Sagar Associates",
    "Nishith Desai Associates",
    "AZB & Partners"
  ],
  globalExposure: {
    description: "Advised corporates, global investment funds, start-ups, and international law firms across varied sectors. Worked extensively with clients across the U.S., U.K., Europe, Japan, Mauritius, and other South Asian jurisdictions.",
    jurisdictions: ["United States", "United Kingdom", "Europe", "Japan", "Mauritius", "South Asian jurisdictions"]
  },
  industryContribution: [
    "Charter Member of TiE",
    "Active contributor through regular publications and industry engagements"
  ],
  values: [
    "Agility", "Execution", "Strategic", "Commercial", "Pragmatic",
    "Analytical", "Reliable", "Insightful", "Consistent",
    "Dedicated", "Integrity", "Excellence"
  ]
};

export const practiceAreas = [
  {
    id: 1,
    title: "Mergers & Acquisitions",
    description: "End-to-end advisory on complex M&A transactions, from structuring and due diligence to negotiation and closing.",
    icon: "Briefcase",
    highlights: [
      "Domestic and cross-border M&A",
      "Joint ventures and strategic alliances",
      "Takeover and control transactions",
      "Strategic acquisitions, divestitures and carveouts",
    ]
  },
  {
    id: 2,
    title: "Venture Capital",
    description: "Comprehensive legal support for startups and venture capital funds across funding rounds and growth stages.",
    icon: "TrendingUp",
    highlights: [
      "Founder agreements and fundraising readiness",
      "Term sheet review, structuring and due diligence",
      "Shareholder agreements negotiations and governance",
      "Exit strategies and secondary transactions"
    ]
  },
  {
    id: 3,
    title: "Private Equity",
    description: "Strategic counsel for PE investments, portfolio management, and exit transactions across sectors.",
    icon: "DollarSign",
    highlights: [
      "Deal structuring and due diligence",
      "Buyout and investment documentation",
      "Portfolio governance, monitoring and support",
      "Exit strategies, secondaries and liquidity solutions"
    ]
  },
  {
    id: 4,
    title: "Corporate & Commercial",
    description: "Day-to-day corporate advisory and commercial contract support for businesses of all sizes.",
    icon: "Building2",
    highlights: [
      "Corporate governance, compliance and policies",
      "Commercial contracts (customer, vendors, partners, etc.)",
      "Regulatory advisory and corporate restructuring",
      "Commercial playbooks for repeatable contracts",
    ]
  },
  {
    id: 5,
    title: "Cross-Border Transactions",
    description: "Seamless coordination for international deals spanning multiple jurisdictions and regulatory frameworks.",
    icon: "Globe",
    highlights: [
      "Inbound/outbound and offshore deals",
      "Navigating FDI, FEMA - sectoral and regulatory nuances",
      "Foreign commercial borrowings and debt issuances",
      "Expansion of Indian companies in international markets",
    ]
  },
  {
    id: 6,
    title: "Employment & Labor Law",
    description: "Strategic employment law advisory for startups and established businesses, ensuring compliance and protecting interests.",
    icon: "Users",
    highlights: [
      "Employment, consulting and independent contractor agreements",
      "Employee handbooks, workplace policies and POSH Compliance",
      "ESOPs, stock options and incentive plans",
      "Termination and separation support",
    ]
  },
  {
    id: 7,
    title: "Technology, Product, IP & Data",
    description: "Legal support for technology-driven businesses, covering product development, intellectual property, and data protection.",
    icon: "Code",
    highlights: [
      "SaaS, product and tech agreements",
      "Technology licensing, transfer and IP considerations in M&A",
      "Data privacy, protection and cross-border data transfers",
      "Product counselling and regulatory compliance"
    ]
  },
  {
    id: 8,
    title: "Internal Investigations & Compliance",
    description: "Support for internal investigations and compliance matters, ensuring that your business remains protected from legal and regulatory risks.",
    icon: "ShieldCheck",
    highlights: [
      "Internal probes and issue assessment",
      "Document review, interviews, and reporting",
      "Remediation and governance improvements",
      "Coodination with external agencies",
    ]
  },
  {
    id: 9,
    title: "Real Estate",
    description: "Real estate legal support for businesses, from leasing and co-working arrangements to development and construction agreements.",
    icon: "Landmark",
    highlights: [
      "Leases and commercial occupancy documentation",
      "Co-working and flexible workspace arrangements",
      "Sale deed, development and construction agreements",
      "Deal-linked real estate workstreams and closing support",
    ]
  },
  {
    id: 10,
    title: "Regulatory & Operational Compliance",
    description: "Operational regulatory support for consumer-facing and manufacturing businesses.",
    icon: "Ruler",
    highlights: [
      "Food safety, labelling, claims, recalls",
      "⁠Legal metrology, MRP, quantity, declarations",
      "⁠Waste, pollution control, ESG reporting",
      "Supply chain compliance and contracting",
    ]
  },
  // {
  //   id: 11,
  //   title: "Execution & Workstreams Support",
  //   description: "When matters spans multiple workstreams, we keep execution on track - working seamlessly with your internal teams and trusted specialists.",
  //   icon: "Zap",
  //   highlights: [
  //     "Corporate secretarial and compliance execution",
  //     "Assistance with regulatory filings and registrations",
  //     "Coordination with valuers, merchant bankers, auditors and tax experts",
  //     "Dispute support, including strategy and counsel management",
  //   ]
  // },
  // {
  //   id: 11,
  //   title: "Sector Expertise",
  //   description: "Deep domain knowledge across emerging and high-growth sectors of the new economy.",
  //   icon: "Zap",
  //   highlights: [
  //     "Technology and SaaS",
  //     "Deep-tech and Artificial Intelligence",
  //     "FinTech & Digital Payments",
  //     "FMCG, retail and consumer goods",
  //     "E-commerce and D2C",
  //     "Manufacturing",
  //     "Mobility and Logistics",
  //     "Real Estate",
  //     "Defence and Aerospace",
  //   ]
  // }
];

export const sectorExpertise = [
  {
    id: 1,
    sector: "Technology and SaaS",
    icon: "Code"
  },
  {
    id: 2,
    sector: "Deep-tech and Artificial Intelligence",
    icon: "Brain"
  },
  {
    id: 3,
    sector: "FinTech & Digital Payments",
    icon: "CreditCard"
  },
  {
    id: 4,
    sector: "FMCG, retail and consumer goods",
    icon: "Package"
  },
  {
    id: 5,
    sector: "E-commerce and D2C",
    icon: "ShoppingCart"
  },
  {
    id: 6,
    sector: "Manufacturing",
    icon: "Factory"
  },
  {
    id: 7,
    sector: "Mobility and Logistics",
    icon: "Car"
  },
  {
    id: 8,
    sector: "Real Estate",
    icon: "Landmark"
  },
  {
    id: 9,
    sector: "Defence and Aerospace",
    icon: "Plane"
  }
]

export const innovativeSolutions = [
  {
    id: 1,
    prefix: "Flexible Retainers",
    title: "Fractional General Counsel",
    tagline: "Your On-Demand Legal Leadership",
    description: "Access senior legal expertise without the overhead of a full-time general counsel. Perfect for growing businesses that need strategic legal guidance on demand.",
    icon: "UserCheck",
    features: [
      "Strategic legal oversight and planning",
      "Day-to-day Contract review and negotiation",
      "Employee training & internal policy playbooks",
      "Investor meeting preparation & secretarial support",
    ],
    idealFor: "Startups, scale-ups, and SMEs seeking senior legal counsel without full-time commitment"
  },
  {
    id: 2,
    prefix: "Deal Based Mandates",
    title: "M&A Buddy",
    tagline: "Your Deal Companion",
    description: "Simplified, transparent M&A advisory designed for founders and first-time dealmakers. We demystify the process and guide you every step of the way.",
    icon: "Handshake",
    features: [
      "Investor deck preparation assistance",
      "Term sheet walkthrough and strategy",
      "Data room management & rapid due diligence sprints",
      "Comprehensive support through documentation and closing",
      "Negotiation support and tactics for Founders, GCs & Investors",
      "Post-closing integration guidance"
    ],
    idealFor: "Founders & Investors navigating acquisitions, fundraising, or exits"
  },
  {
    id: 3,
    prefix: "Ad-hoc Assistance",
    title: "Smart Doc Review",
    tagline: "Efficient, Focused Contract Analysis",
    description: "Fast-track contract reviews with AI-assisted analysis and expert legal oversight. Get clear, actionable insights without the traditional billable hour burden.",
    icon: "FileSearch",
    features: [
      "Rapid contract analysis",
      "Risk identification and flagging",
      "Commercial terms review",
      "Redlining and recommendations",
      "High volume contract review"
    ],
    idealFor: "Businesses needing quick turnaround on NDAs, vendor agreements, and standard contracts"
  }
];

export const thoughtLeadership = [
  {
    id: 1,
    title: "Deal Playbooks",
    description: "Comprehensive guides on executing various transaction types, packed with practical insights and best practices.",
    icon: "BookOpen",
    topicHoverIcon: "Download",
    buttonText: "Request Playbook",
    popupTitle: "Request a Deal Playbook",
    popupDescription: "Provide your email and we'll send the selected playbook directly to your inbox.",
    popupSubjectPrefix: "Request: Deal Playbook -",
    formType: "minimal",
    topics: [
      "Startup Funding Playbook: Seed to Series A",
      "Asset Sale vs Share Sale: Choosing the Right Route",
      "Due Diligence, Simplified: A Practical Playbook",
      "Cross-Border Deal Structuring"
    ]
  },
  {
    id: 2,
    title: "Founder Essentials",
    description: "Interactive sessions designed to equip founders with legal knowledge crucial for building and scaling businesses.",
    icon: "Users",
    topicHoverIcon: "Calendar",
    buttonText: "Request Insight",
    popupTitle: "Request Founder Insights",
    popupDescription: "Tell us which topic interests you and our team will share the relevant insights or session details.",
    popupSubjectPrefix: "Inquiry: Founder Resource -",
    formType: "minimal",
    topics: [
      "Funding instruments 101: Equity, CCPS, Debt and Notes",
      "Negotiating Your First Term Sheet",
      "IP Protection for Tech Startups",
      "Corporate Governance for Growth"
    ]
  },
  {
    id: 3,
    title: "General Counsel Toolkit",
    description: "Comprehensive guides on executing various transaction types, packed with practical insights and best practices.",
    icon: "Drill",
    topicHoverIcon: "Wrench",
    buttonText: "Request Asset",
    popupTitle: "General Counsel Resources",
    popupDescription: "Deep-dive resources for legal professionals and corporate leadership.",
    popupSubjectPrefix: "Request: GC Toolkit -",
    formType: "minimal",
    topics: [
      "M&A Readiness: Common Red Flags",
      "Tech Hiring: Employment & Contractor Docs",
      "Exits: Separation & Termination Docs",
      "Understanding Risk: Reps, Warranties, Indemnities, Liabilities"
    ]
  }
  // {
  //   id: 3,
  //   title: "Sector Primers",
  //   description: "In-depth analysis of legal and regulatory landscapes across key sectors, helping clients stay ahead of the curve.",
  //   icon: "FileText",
  //   topics: [
  //     "AI & Machine Learning: Regulatory Landscape",
  //     "FinTech Compliance in India",
  //     "Healthcare M&A: Key Considerations",
  //     "SaaS Business Models: Legal Framework"
  //   ]
  // }
];

export const globalRequests = {
  firmProfile: {
    title: "Request Firm Profile",
    description: "Get a comprehensive overview of LEXCEED's expertise, experience, and value proposition.",
    buttonText: "Request Profile",
    subject: "Request: LEXCEED Firm Profile",
    formType: "minimal"
  },
  consultation: {
    title: "Schedule a Consultation",
    description: "Let's discuss your legal needs and how we can help you exceed your benchmarks.",
    buttonText: "Request Call",
    subject: "Request: Legal Consultation",
    formType: "full"
  }
};

export const heroStats = [
  {
    value: "10+",
    label: "Years of Experience"
  },
  {
    value: "Multiple",
    label: "Jurisdictions Covered"
  },
  {
    value: "Top Tier",
    label: "Prior Firm Experience"
  },
  {
    value: "360°",
    label: "Legal Advisory"
  }
];

export const heroAttributes = [
  {
    icon: "Globe",
    value: "Multi-Jurisdictional Expertise"
  },
  {
    icon: "BookOpen",
    value: "Deep Institutional Knowledge"
  },
  {
    icon: "Pencil",
    value: "Boutique Precision"
  },
  {
    icon: "Settings",
    value: "Outcome Oriented Advice"
  }
];

export const testimonials = [
  {
    id: 1,
    quote: "LEXCEED provided exceptional guidance through our Series A funding round. Their clarity and execution made a complex process seamless.",
    author: "Tech Startup Founder",
    company: "SaaS Platform",
    role: "CEO"
  },
  {
    id: 2,
    quote: "The fractional GC model has been transformative for our business. We get top-tier legal expertise exactly when we need it.",
    author: "Growth Company",
    company: "FinTech Venture",
    role: "CFO"
  },
  {
    id: 3,
    quote: "Professional, responsive, and deeply knowledgeable. LEXCEED exceeded our expectations on a multi-jurisdictional acquisition.",
    author: "Corporate Client",
    company: "Manufacturing Group",
    role: "General Counsel"
  }
];
